'use client';

import dynamic from 'next/dynamic';

// Dynamic import of AuthDialog with ssr: false
// This ensures the component is only loaded and rendered on the client side
const AuthDialog = dynamic(() => import('@/components/auth-dialog'), {
  loading: () => null,
  ssr: false,
});

/**
 * AuthDialog Wrapper Component
 * Wraps the dynamically imported AuthDialog in a Client Component
 * This allows us to use ssr: false in a Server Component context
 */
export default function AuthDialogWrapper() {
  return <AuthDialog />;
}
